export default __webpack_public_path__ + "static/media/chemistry_icon.6f8e28b5.svg";